(() => {
  const getStoreStockDisplayState = ({
    hasStoreStock,
    hasExplicitSizeSelection,
    selectedVariantId,
    availableVariantIds,
  }) => {
    const availableIds = Array.isArray(availableVariantIds) ? availableVariantIds.map(String) : [];
    const hasExactSelection = Boolean(hasStoreStock && hasExplicitSizeSelection && selectedVariantId);
    const selectedVariantIsInStore = hasExactSelection && availableIds.includes(String(selectedVariantId));

    return {
      showConfirmation: selectedVariantIsInStore,
      showUnavailable: hasExactSelection && !selectedVariantIsInStore,
    };
  };

  const shouldRecordExplicitSizeSelection = ({
    isTrusted,
    hasSizeOption,
    changedSize,
    hasOptionValue,
  }) => Boolean(isTrusted && ((hasSizeOption && changedSize) || (!hasSizeOption && hasOptionValue)));

  const shouldShowStoreMap = ({ showConfirmation, showUnavailable }) =>
    Boolean(showConfirmation || showUnavailable);

  if (typeof window !== 'undefined') {
    window.__zicoLadpraoStoreMapState = {
      getStoreStockDisplayState,
      shouldRecordExplicitSizeSelection,
      shouldShowStoreMap,
    };
  }

  if (typeof document === 'undefined') return;

  const explicitSelections = new Map();

  const mapKey = (storeMap) => storeMap.dataset.zLadpraoSection || storeMap.id;

  const parseAvailableVariantIds = (storeMap) => {
    try {
      const value = JSON.parse(storeMap.dataset.zLadpraoAvailableVariants || '[]');
      return Array.isArray(value) ? value.map(String) : [];
    } catch {
      return [];
    }
  };

  const parseSelectedVariantId = (storeMap) => {
    try {
      const variantSelects = storeMap.closest('variant-selects');
      const selectedVariant = JSON.parse(variantSelects?.querySelector('[data-selected-variant]')?.textContent || 'null');
      return selectedVariant?.id ? String(selectedVariant.id) : null;
    } catch {
      return null;
    }
  };

  const updateStoreMap = (storeMap) => {
    const displayState = getStoreStockDisplayState({
      hasStoreStock: parseAvailableVariantIds(storeMap).length > 0,
      hasExplicitSizeSelection: explicitSelections.get(mapKey(storeMap)) === true,
      selectedVariantId: parseSelectedVariantId(storeMap),
      availableVariantIds: parseAvailableVariantIds(storeMap),
    });

    const confirmation = storeMap.querySelector('[data-z-ladprao-confirmation]');
    const unavailable = storeMap.querySelector('[data-z-ladprao-unavailable]');

    storeMap.hidden = !shouldShowStoreMap(displayState);
    if (confirmation) confirmation.hidden = !displayState.showConfirmation;
    if (unavailable) unavailable.hidden = !displayState.showUnavailable;
  };

  const initializeStoreMaps = () => {
    document.querySelectorAll('[data-z-ladprao-store-map]').forEach((storeMap) => {
      if (!storeMap.dataset.zLadpraoConnected) {
        storeMap.dataset.zLadpraoConnected = 'true';
      }

      updateStoreMap(storeMap);
    });
  };

  const getChangedOption = (target) => {
    if (target?.tagName === 'SELECT') return target.selectedOptions[0];
    return target;
  };

  document.addEventListener(
    'change',
    (event) => {
      const option = getChangedOption(event.target);
      const variantSelects = option?.closest?.('variant-selects');
      if (!variantSelects) return;

      const hasSizeOption = Boolean(variantSelects.querySelector('[data-zico-size-option="true"]'));
      const changedSize = option?.dataset?.zicoSizeOption === 'true';
      const hasOptionValue = Boolean(option?.dataset?.optionValueId);
      if (!shouldRecordExplicitSizeSelection({
        isTrusted: event.isTrusted,
        hasSizeOption,
        changedSize,
        hasOptionValue,
      })) return;

      const storeMap = variantSelects.querySelector('[data-z-ladprao-store-map]');
      if (storeMap) explicitSelections.set(mapKey(storeMap), true);
    },
    true
  );

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest?.('[data-z-ladprao-open]');
    if (openButton) {
      const dialog = openButton.closest('[data-z-ladprao-store-map]')?.querySelector('[data-z-ladprao-dialog]');
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    const closeButton = event.target.closest?.('[data-z-ladprao-close]');
    if (closeButton) closeButton.closest('dialog')?.close();
  });

  const start = () => {
    initializeStoreMaps();
    new MutationObserver(initializeStoreMaps).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, initializeStoreMaps);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
